import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";


export default css`
  .stickyBarFilter {
    position: fixed;
    bottom: 25px;
    z-index: 30;
    color: white;
    width: max-content;
    height: 40px;
    width: auto;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.3s ease-in-out;
    display: flex;
    .scroll-up-button {
      display: flex;
    }
    .badgeFiltrosMobile {
      display: none;
    }
  }

  .stickyBarFilter.visible {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  .scroll-up-button {
    position: absolute;
    z-index: 31;
    right: 20px;
    background-color: ${getColor(COLOR_DICTIONARY.BLUE_800)};
    color: white;
    width: 50px;
    padding-bottom: 2px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    border: 1px solid white;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.3s ease-in-out;
  }

  .scroll-up-button:hover {
    background-color: rgba(1, 73, 179, 0.8);
    opacity: 0.8;
  }

  .badgeFiltrosMobile {
    font: inherit;
    min-width: 125px;
    margin-left: 10px;
    margin-right: 5px;

    padding: 5px 20px;
    -webkit-letter-spacing: 0px;
    -moz-letter-spacing: 0px;
    -ms-letter-spacing: 0px;
    letter-spacing: 0px;
    display: flex;
    color: white;
    background: ${getColor(COLOR_DICTIONARY.BLUE_800)};
    border: 1px solid white;
    border-radius: 15px;
    opacity: 1;
    align-items: center;
    justify-content: space-between;
    font-family: Regular;
  }

  .badgeFiltrosMobile:hover {
    background-color: rgb(1, 73, 179, 0.8);
    opacity: 0.8;
  }

  .badgeFiltrosMobile:focus-visible,
  .scroll-up-button:focus-visible {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 3px;
  }

  .filterCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btnUpEnd {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  :global(.badgeFiltrosMobile .svg-layout-size) {
    margin-left: 8px;
  }

  @media (max-width: 1067px) {
    .stickyBarFilter {
      .badgeFiltrosMobile {
        display: flex;
      }
    }
  }
  @media (min-width: 1069px) {
    .stickyBarFilter {
      .scroll-up-button {
        right: 12.5rem;
        width: 3.75rem;
        height: 3.75rem;
      }
    }
  }
`;
